import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSearch, FiLayers, FiZap, FiBarChart } = FiIcons;

const Process = () => {
  const steps = [
    {
      icon: FiSearch,
      title: "Discovery & Diagnosis",
      desc: "Memahami bisnis, target market, dan hambatan Anda."
    },
    {
      icon: FiLayers,
      title: "Strategic Planning",
      desc: "Menyusun sistem digital sesuai tujuan bisnis."
    },
    {
      icon: FiZap,
      title: "Execution & Build",
      desc: "Implementasi website, landing page, GBP, dan sistem pendukung."
    },
    {
      icon: FiBarChart,
      title: "Optimization & Growth",
      desc: "Optimasi berkelanjutan berdasarkan data & performa."
    }
  ];

  return (
    <section id="process" className="py-24 bg-[#0A192F] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-5xl font-black text-white mb-6">Cara Kami <span className="text-orange-500">Bekerja</span></h2>
          <div className="w-24 h-1.5 bg-orange-500 mx-auto rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, idx) => (
            <div key={idx} className="relative group">
              {idx !== steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/4 -right-4 w-8 h-0.5 bg-orange-500/30"></div>
              )}
              <div className="bg-white/5 border border-white/10 p-8 rounded-[2.5rem] h-full hover:border-orange-500 transition-all text-center">
                <div className="w-16 h-16 bg-orange-500/10 rounded-2xl flex items-center justify-center mx-auto mb-6 text-orange-500 text-3xl group-hover:bg-orange-500 group-hover:text-white transition-all">
                  <SafeIcon icon={step.icon} />
                </div>
                <h3 className="text-xl font-black text-white mb-4">{step.title}</h3>
                <p className="text-gray-400 font-medium leading-relaxed">{step.desc}</p>
                <div className="absolute -top-4 -left-4 w-10 h-10 bg-[#0A192F] border border-white/10 rounded-full flex items-center justify-center text-orange-500 font-black">
                  0{idx + 1}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;